import { render, staticRenderFns } from "./OtherPartyCommonSurvey.vue?vue&type=template&id=a95aeec4"
import script from "./OtherPartyCommonSurvey.vue?vue&type=script&lang=ts"
export * from "./OtherPartyCommonSurvey.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports